<template>
  <SoPageWithHeader title="Edit Article">
    <NewsfeedEnvironmentWarning />
    <SoAlert
      v-if="articleQuery?.error"
      type="error"
      title="Failed to load article"
      data-testid="article-error-alert"
    />
    <div
      v-else-if="articleQuery?.isFetching"
      class="d-flex justify-center pa-8"
    >
      <v-progress-circular indeterminate color="primary" />
    </div>
    <AdminNewsfeedArticleForm
      v-else-if="articleQuery?.data"
      mode="edit"
      :article="articleQuery.data"
      @success="onSuccess"
      @deleted="onDeleted"
    />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import AdminNewsfeedArticleForm from "./components/AdminNewsfeedArticleForm.vue"
  import NewsfeedEnvironmentWarning from "./components/NewsfeedEnvironmentWarning.vue"
  import { NewsfeedService } from "@/services/NewsfeedService"
  import { RouteNames } from "@/types/router"
  import { useSnackbarStore } from "@/stores/snackbar"

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoAlert,
      AdminNewsfeedArticleForm,
      NewsfeedEnvironmentWarning,
    },
    data() {
      return {
        snackbar: useSnackbarStore(),
        articleQuery: null as ReturnType<
          typeof NewsfeedService.getAdminArticle
        > | null,
      }
    },
    watch: {
      "$route.params.articleId": {
        immediate: true,
        handler(articleId: string) {
          if (articleId) {
            this.articleQuery = NewsfeedService.getAdminArticle(articleId)
          }
        },
      },
    },
    methods: {
      onSuccess() {
        this.snackbar.addSuccess("Article updated successfully")
        this.articleQuery?.refetch()
      },
      onDeleted() {
        this.snackbar.addSuccess("Article deleted successfully")
        this.$router.push({ name: RouteNames.AdminNewsfeed })
      },
    },
  })
</script>
